<div class="row justify-content-center">
    <div class="col-9">
        <div class="card">
            <div class="card-header text-center fs-1" translate="HOME_PAGE_TITLE"></div>
            <div class="card-body">
                <div class="container">
                    <p class="card-title" translate="HOME_PAGE_DESCRIPTION"></p>
                    <form [formGroup]="homePageFormGroup">
                        <div class="form-container">
                            <div class="form-elements">
                                <div class="form-control-item">
                                    <pace-authors-dropdown
                                        label="HOME_PAGE_LABEL_DOCUMENT_ID"
                                        formControlName="documentId"
                                        [options]="formsList$ | async"
                                    >
                                    </pace-authors-dropdown>
                                </div>
                            </div>
                            <div class="form-elements" formGroupName="matSerialNumber">
                                <div class="form-control-item">
                                    <label for="materialNumber" translate="HOME_PAGE_LABEL_MATERIAL"></label>
                                    <input class="form-control" formControlName="materialNumber" id="materialNumber" />
                                </div>
                                <div class="form-control-item">
                                    <label for="serialNumber" translate="HOME_PAGE_LABEL_SERIAL"></label>
                                    <input class="form-control" formControlName="serialNumber" id="serialNumber" />
                                </div>
                            </div>
                        </div>
                        <div class="form-container">
                            <button
                                type="button"
                                class="btn btn-primary btn-lg"
                                (click)="submitForm()"
                                [disabled]="!homePageFormGroup.valid"
                                translate="HOME_PAGE_BUTTON_SUBMIT"
                            ></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
